module.exports = {
  host: process.env.apiHost,
  omsHost: process.env.apiHostOms,
  khsHost: process.env.apiHostKhs,
  index: process.env.index,
  local: process.env.local,
  imgUrl: process.env.imgUrl,
  hhsHost: process.env.hhsHost,
  surveywebUrl: process.env.surveyurl
}



// WEBPACK FOOTER //
// ./src/com/config.js